const ercRegex = /^0x[a-fA-F0-9]{40}$/;
const btcRegex = /^(bc1|[13])[a-zA-HJ-NP-Z0-9]{25,39}$/;
const ltcRegex = /^[LM][a-km-zA-HJ-NP-Z1-9]{26,35}$/;
const rippleRegex = /^r[0-9a-zA-Z]{24,34}$/;
const btcCoinRegex = /^[13][a-km-zA-HJ-NP-Z1-9]{33}$/;
const bnbRegex = /^0x[a-fA-F0-9]{40}$/;
const cardanoRegex = /^addr1[0-9a-zA-Z]{103}$/;
const cosmosRegex = /^(cosmos1|cosmospub)[a-z0-9]{38}/;
const xlmRegex = /^G[A-Z0-9]{55}$/;
const solRegex = /^([1-9A-HJ-NP-Za-km-z]{32,44})$/;
const dotRegex = /^([1-9A-HJ-NP-Za-km-z]{46,47})|([1-9A-HJ-NP-Za-km-z]{50,51})$/;
const dogeRegex = /^D[QW][a-zA-Z0-9]{33}$/;
const xdcRegex = /^xdc[0-9a-fA-F]{40}$/;
const hbarRegex = /^0.0.[0-9]{1,18}[1-9]$/;

const top100Ethereum = [
  "ETH",
  "SHIB",
  "USDT",
  "WBTC",
  "UNI",
  "USDC",
  "LINK",
  "AAVE",
  "DAI",
  "SUSHI",
  "MKR",
  "SNX",
  "COMP",
  "BAT",
  "BAL",
  "YFI",
  "REN",
  "ENJ",
  "GRT",
  "CRV",
  "MANA",
  "UMA",
  "MTA",
  "RARI",
  "MIR",
  "BNT",
  "FTT",
  "KNC",
  "FRAX",
  "ALPHA",
  "STORJ",
  "1INCH",
  "OCEAN",
  "MASK",
  "AMPL",
  "DODO",
  "RENBTC",
  "CEL",
  "LRC",
  "SRM",
  "ZRX",
  "ROOK",
  "CVP",
  "LIDO",
  "GNO",
  "BOND",
  "GHST",
  "WING",
  "PAXG",
  "NMR",
  "RPL",
  "BASIC",
  "GRT",
  "STAKE",
  "KAVA",
  "SWAP",
  "PERP",
  "FRONT",
  "TRIBE",
  "FARM",
  "SNT",
  "FET",
  "SAND",
  "RUNE",
  "COTI",
  "ANKR",
  "ROOK",
  "CRV",
  "NFTX",
  "OXT",
  "COVER",
  "BID",
  "HOT",
  "MATIC",
  "ORN",
  "PICKLE",
  "SFI",
  "HEGIC",
  "DEGO",
  "LINA",
  "AXS",
  "PERL",
  "KP3R",
  "HAPPY",
  "ROCKS",
  "DHT",
  "TORN",
  "NFT",
  "VALUE",
  "DXD",
  "MTLX",
];

const isERC20 = (code: string): boolean => {
  if (!code) return false;
  return top100Ethereum.includes(code.toUpperCase());
};

export const isERC20Regex = (address: string): boolean => {
  if (!address) return false;

  return ercRegex.test(address);
};

export const formatAddressCheck = (code: string, address: string): boolean => {
  let isValid = false;

  switch (code) {
    case "XRP":
      isValid = rippleRegex.test(address);
      break;
    case "BNB":
      isValid = bnbRegex.test(address);
      break;
    case "ATOM":
    case "COSMOS":
      isValid = cosmosRegex.test(address);
      break;
    case "XLM":
      isValid = xlmRegex.test(address);
      break;
    case "SOL":
      isValid = solRegex.test(address);
      break;
    case "BCH":
      isValid = btcCoinRegex.test(address);
      break;
    case "XEM":
      isValid = btcCoinRegex.test(address);
      break;
    case "LTC":
      isValid = ltcRegex.test(address);
      break;
    case "DOT":
      isValid = dotRegex.test(address);
      break;
    case "BTC":
      isValid = btcRegex.test(address);
      break;
    case "ARB":
    case "GMX":
      isValid = ercRegex.test(address);
      break;
    case "ADA":
      isValid = cardanoRegex.test(address);
      break;
    case "DOGE":
      isValid = dogeRegex.test(address);
      break;
    case "XDC":
      isValid = xdcRegex.test(address);
      break;
    case "HBAR":
      isValid = hbarRegex.test(address);
      break;
    default:
      isValid = isERC20(code) ? ercRegex.test(address) : false;
      break;
  }
  return isValid;
};
